export default {"src":"/_next/static/media/loading.3170e5c7.gif","height":480,"width":475,"blurWidth":0,"blurHeight":0};